import dayjs from "dayjs";

export const isValidDate = startDate => {
	if (startDate) {
		const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
		const match = startDate.match(regex);
		if (!match) return false;

		const day = parseInt(match[1], 10);
		const month = parseInt(match[2], 10);
		const year = parseInt(match[3], 10);

		const date = new Date(year, month - 1, day);
		return (
			date.getFullYear() === year &&
			date.getMonth() === month - 1 &&
			date.getDate() === day
		);
	}
};

export const formatRelativeTime = dateString => {
	const now = dayjs();
	const date = dayjs(dateString);

	const diffInMinutes = now.diff(date, "minute");
	const diffInHours = now.diff(date, "hour");
	const diffInDays = now.diff(date, "day");
	const diffInMonths = now.diff(date, "month");
	const diffInYears = now.diff(date, "year");

	if (diffInMinutes < 60) {
		if (diffInMinutes === 1) return "1 minuto atrás";
		return `${diffInMinutes} minutos atrás`;
	}

	if (diffInHours < 24) {
		if (diffInHours === 1) return "1 hora atrás";
		return `${diffInHours} horas atrás`;
	}

	if (diffInDays < 30) {
		if (diffInDays === 1) return "1 dia atrás";
		return `${diffInDays} dias atrás`;
	}

	if (diffInMonths < 12) {
		if (diffInMonths === 1) return "1 mês atrás";
		return `${diffInMonths} meses atrás`;
	}

	if (diffInYears === 1) return "1 ano atrás";
	return `${diffInYears} anos atrás`;
};
